<template>
    <div class="menu-dropdown">
        <!-- Items come from the `nav.menu` extension point -->
        <template v-for="item in items">
            <div v-if="item.children" :key="item.key" class="menu-drop-parent" :class="{ open: openGroups.includes(item.key) }">
                <div class="menu-drop-item menu-drop-item--has-sub" @click="toggleGroup(item.key)">
                    <span>{{ $t(item.label) }}</span>
                    <svg class="sub-arrow" width="14" height="14" viewBox="0 0 16 16" fill="none">
                        <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <transition name="sub-drop">
                    <div v-if="openGroups.includes(item.key)" class="menu-sub-dropdown">
                        <router-link
                            v-for="child in item.children"
                            :key="child.to"
                            :to="child.to"
                            class="menu-sub-item"
                            active-class="menu-sub-item-active"
                            @click.native="$emit('close')"
                        >{{ $t(child.label) }}</router-link>
                    </div>
                </transition>
            </div>
            <router-link v-else :key="item.key" :to="item.to" class="menu-drop-item" active-class="menu-drop-item-active" @click.native="$emit('close')">
                <span>{{ $t(item.label) }}</span>
            </router-link>
        </template>

        <button class="menu-drop-logout" @click="logout">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('nav.logout') }}
        </button>
    </div>
</template>

<script>
import { logout } from '@/core/http/api';

export default {
    name: 'NavUserMenu',
    data() {
        return { openGroups: [] };
    },
    computed: {
        items() {
            const { loggedIn, memberInfo } = this.$sharedState;
            return this.$modules.items('nav.menu', { loggedIn, memberInfo });
        }
    },
    methods: {
        toggleGroup(key) {
            this.openGroups = this.openGroups.includes(key)
                ? this.openGroups.filter(k => k !== key)
                : [...this.openGroups, key];
        },
        logout() {
            this.$emit('close');
            // Send the request while the token is still stored.
            logout().catch(() => {});
            localStorage.removeItem('gamingToken');
            this.$sharedState.memberInfo = {};
            this.$root.$emit('login-state-changed');
            if (this.$route.path !== '/') this.$router.push('/');
        }
    }
};
</script>

<style lang="scss" scoped>
.menu-dropdown {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    min-width: 200px;
    background: linear-gradient(165deg, var(--surface-3) 0%, var(--surface-0) 100%);
    border: 1px solid var(--border);
    border-radius: 12px;
    overflow: hidden;
    z-index: 300;
    box-shadow: 0 8px 24px color-mix(in srgb, var(--black) 50%, transparent);
}

.menu-drop-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    text-decoration: none;
    border-bottom: 1px solid var(--surface-hover);
    transition: background 0.15s;

    span {
        color: var(--text-sub);
        font-size: 14px;
        font-weight: 600;
        font-family: 'Urbanist', sans-serif;
    }

    &:hover {
        background: var(--surface-hover);
    }

    &.menu-drop-item-active span {
        color: var(--highlight);
    }
}

.menu-drop-logout {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 12px 16px;
    border: none;
    background: transparent;
    color: var(--error);
    font-size: 14px;
    font-weight: 600;
    font-family: 'Urbanist', sans-serif;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
        background: color-mix(in srgb, var(--error) 8%, transparent);
    }
}

.menu-drop-parent {
    .menu-drop-item--has-sub {
        cursor: pointer;

        .sub-arrow {
            color: var(--text-tab);
            transition: transform 0.2s ease;
        }
    }

    &.open .sub-arrow {
        transform: rotate(180deg);
    }
}

.menu-sub-dropdown {
    background: color-mix(in srgb, var(--black) 15%, transparent);
    border-top: 1px solid var(--surface-hover);
}

.menu-sub-item {
    display: block;
    padding: 10px 16px 10px 28px;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-sub);
    text-decoration: none;
    border-bottom: 1px solid var(--surface-hover);
    transition: background 0.15s;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: var(--surface-hover);
    }

    &.menu-sub-item-active {
        color: var(--highlight);
    }
}

.sub-drop-enter-active,
.sub-drop-leave-active {
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.sub-drop-enter,
.sub-drop-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}
</style>
